import React, { createContext, useContext, useState, useEffect } from "react";

const BookingContext = createContext();
export const useBooking = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const initialBookings = (() => {
    try {
      const v = localStorage.getItem("bookings");
      return v ? JSON.parse(v) : [];
    } catch {
      return [];
    }
  })();

  const storedPickupService =
    localStorage.getItem("pickupService") || "in-store";
  const [address, setAddress] = useState("");

  const initialAddressMap = (() => {
    try {
      const v = localStorage.getItem("deliveryAddressMap");
      return v ? JSON.parse(v) : {};
    } catch {
      return {};
    }
  })();

  const [bookings, setBookings] = useState(initialBookings);
  const [pickupService, setPickupService] = useState(storedPickupService);
  const [addressMap, setAddressMap] = useState(initialAddressMap);
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    localStorage.setItem("bookings", JSON.stringify(bookings));
  }, [bookings]);

  useEffect(() => {
    localStorage.setItem("pickupService", pickupService);
  }, [pickupService]);

  useEffect(() => {
    try {
      localStorage.setItem("deliveryAddressMap", JSON.stringify(addressMap));
    } catch {}
  }, [addressMap]);

  const addBooking = (newBooking) => {
    setBookings((prev) => [...prev, newBooking]);
  };

  const getAddressForCustomer = (customerId) => {
    if (!customerId) return "";
    return addressMap?.[customerId] || "";
  };

  const setAddressForCustomer = (customerId, addr) => {
    if (!customerId) return;
    setAddressMap((prev) => {
      const next = { ...prev };
      if (addr && addr.trim()) {
        next[customerId] = addr;
      } else {
        delete next[customerId];
      }
      return next;
    });
  };

  return (
    <BookingContext.Provider
      value={{
        bookings,
        setBookings,
        pickupService,
        setPickupService,
        address,
        setAddress,
        addressMap,
        getAddressForCustomer,
        setAddressForCustomer,
        customer,
        setCustomer,
        addBooking,
      }}
    >
      {children}
    </BookingContext.Provider>
  );
};
